module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Open Space Technology")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "CSS_1.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dedication"
  }, [_c('a', {
    attrs: {
      "id": "pagev"
    }
  }, [_c('p', [_c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "d7e2786"
    }
  }, [_c('i', [_vm._v("To all the people from all over the world ")]), _c('br'), _c('i', [_vm._v("who have joined me in the cocreation of Open Space ")]), _c('br'), _c('i', [_vm._v("–thank you for the journey!")])])])]), _c('a', {
    attrs: {
      "id": "pagev"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c5ae74a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dedication.vue
// module id = 69
// module chunks = 0